<template>
    <component
        :is="tag"
        v-html="toMarkdown(content)"
    >
    </component>
</template>

<script>/* eslint-disable */

	export default {
        name: 'Markdown',
        props: {
            tag: {
                type: String,
                default: 'div'
            },
            content: {
                type: String,
                default: null
            },
        },
        methods: {

            toMarkdown(content) {
                return this.$options.filters.md(content)
            },

        }
	}
</script>
